import { render } from "./StockTransferCreateView.vue?vue&type=template&id=5201c211"
import script from "./StockTransferCreateView.vue?vue&type=script&lang=js"
export * from "./StockTransferCreateView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__